import { HttpClient, HttpContext, HttpHeaders, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { UserDetailService } from '../user-detail.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { result } from 'lodash';
import { SKIP_LOADER } from 'src/app/interceptor/loader.interceptor';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private httpClient: HttpClient, public commonFunction: CommonFunction,
    private userDetailService: UserDetailService) { }


  get(request): Observable<any> {
    const headers = this.addHeaders();
    const options: { headers: HttpHeaders; context?: HttpContext } = { headers };
    if (request.skipLoader) {
      options.context = new HttpContext().set(SKIP_LOADER, true);
    }

    return this.httpClient.get(environment.pssServerUrl + request.URL, options)
      .map(res => res);

  }
  getGovEvaCallLogout(request) {
    var headers = this.addGovevaHeaders();
    return this.httpClient.get(environment.clientUrl + request.URL, { headers: headers })
      .map((res: Response) => res.json());
  }

  getGovEvaCall(request) {
    var headers = this.addGovevaHeaders();
    return this.httpClient.get(environment.clientUrl + request.URL, { headers: headers })
      .pipe(
        map((res: any) => {
          let parsedResult = res && res.result;
          if (typeof parsedResult === 'string') {
            try {
              const decrypted = this.commonFunction.decrypt(parsedResult);
              if (decrypted && decrypted.trim().length > 0) {
                try {
                  parsedResult = JSON.parse(decrypted);
                } catch (e) {
                  // Not JSON, return decrypted string as-is
                  parsedResult = decrypted;
                }
              }
            } catch (e) {
              // Decrypt failed (likely not encrypted). Try to JSON.parse original, else keep as-is
              try {
                parsedResult = JSON.parse(parsedResult);
              } catch (_) {
                // leave parsedResult as the original string
              }
            }
          }
          // If it's already an object/array or undefined, just pass through
          return { ...res, result: parsedResult };
        })
        // map((res: any) => ({ ...res.json(), result: JSON.parse(this.commonFunction.decrypt(res.json().result)) }))
      );
  }

  // getGovEvaCallLogout(request) {
  //     var headers = this.addGovevaHeaders();
  //     return this.http.get(environment.clientUrl + request.URL, { headers: headers })
  //         .map(res => res.json());
  // }

  // getGovEvaCallPost(request) {
  //     var headers = this.addGovevaHeaders();
  //     return this.http.post(environment.clientUrl + request.URL, request.DATA, { headers: headers })
  //         .map(res => res.json());
  // }

  // getByID(request) {
  //     var headers = this.addHeaders();
  //     return this.http.get(environment.pssServerUrl + request.URL + request.DATA, { headers: headers })
  //         .map(res => res.json());
  // }

  post(request, extraHeaders?: { [key: string]: string }) {
    var headers = this.addHeaders();
    if (extraHeaders) {
      Object.keys(extraHeaders).forEach((key) => {
        if (extraHeaders[key] != null && extraHeaders[key] !== '') {
          headers = headers.set(key, extraHeaders[key]);
        }
      });
    }

    let options: any = {
      headers: headers
    };


    return this.httpClient.post(environment.pssServerUrl + request.URL, request.DATA, options)
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }
  // postForToken(request) {
  //     var headers = this.addHeadersToken();
  //     return this.http.post(environment.pssServerUrl + request.URL, request.DATA, { headers: headers })
  //         .map(res => res.json());
  // }

  addHeaders() {
    var PSSDetail = this.userDetailService.pssDetail();
    var UserDetail = this.userDetailService.getUserDetail();

    var getUserID = this.userDetailService.getUserID();

    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
      'PSSDetail': PSSDetail,
      'UserDetail': UserDetail,
      'x-access-token': localStorage.getItem('token'),
    });
    // var headers = new HttpHeaders();
    // let params = new URLSearchParams();
    // // params.append("someParamKey", this.someParamValue)
    // headers.append('Content-Type', 'application/json');
    // headers.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
    // headers.append('PSSDetail', PSSDetail);
    // headers.append('UserDetail', UserDetail);
    // var token = localStorage.getItem('token')
    // headers.append("x-access-token", token)
    return headers;
  }
  addHeadersToken() {
    var PSSDetail = this.userDetailService.pssDetail();
    var UserDetail = this.userDetailService.getUserDetail();

    var getUserID = this.userDetailService.getUserID();
    var headers = new Headers();
    let params = new URLSearchParams();
    // params.append("someParamKey", this.someParamValue)
    headers.append('Content-Type', 'application/json');
    headers.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

    headers.append('PSSDetail', PSSDetail);
    headers.append('UserDetail', UserDetail);
    var token = localStorage.getItem('token')
    headers.append("x-access-token", token)
    headers.append("check-token", "YES")
    return headers;
  }

  addGovevaHeaders() {
    var companyDetails = this.userDetailService.govevaDetail();
    // var UserDetail = this.userDetailService.getUserDetail();
    var getUserID = this.userDetailService.getUserID();
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Content-Type', 'charset=utf-8');
    headers.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
    if (companyDetails && companyDetails !== 'null' && companyDetails !== 'undefined') {
      headers.append('govevacompany', companyDetails);
    }
    // headers.append('UserDetail', UserDetail);
    var token = localStorage.getItem('token')
    if (token) {
      headers.append("x-access-token", token);
    }
    return headers;
  }

  public upload(request: any, data: any, id): Promise<any> {
    // var headers = this.addHeaders();

    return new Promise((resolve, reject) => {
      const uploadData = new FormData();
      uploadData.append('SrNo', data.SrNo);
      uploadData.append('myFile', data.file);
      uploadData.append('IssueId', data.IssueId);
      uploadData.append('DocumentName', data.DocumentName);
      uploadData.append('ModifiedDate', new Date(data.file.lastModifiedDate).toUTCString());
      uploadData.append('FileSize', data.file.size);
      uploadData.append('FileType', data.file.type);
      uploadData.append('OriginalFileName', data.file.name);

      // var headers = new Headers();
      var token = localStorage.getItem('token')
      // headers.append("x-access-token", token)
      var headers = new HttpHeaders().set('x-access-token', token);

      if (id) {
        this.httpClient.put(environment.pssServerUrl + request.URL + '/' + id, uploadData, { headers })
          .subscribe((event: any) => {
            console.log(event)
            resolve(event);
          },
            error => reject(error)
          );
      } else {
        this.httpClient.post(environment.pssServerUrl + request.URL, uploadData, { headers })
          .subscribe((event: any) => {
            console.log(event)
            resolve(event);
          },
            error => reject(error)
          );
      }
    });
  }

  public uploadMultipleDocs(request: any, data: any): Promise<any> {
    // var headers = this.addHeaders();
    return new Promise((resolve, reject) => {
      const uploadData = new FormData();
      for (let i = 0; i < data.length; i++) {
        uploadData.append('myFile' + i, data[i]);
      }
      var token = localStorage.getItem('token');
      var headers = new HttpHeaders().set('x-access-token', token);
      this.httpClient.post(environment.pssServerUrl + request.URL, uploadData, { headers })
        .subscribe((event: any) => {
          resolve(event);
        },
          error => reject(error)
        );
    })
  }
  getByID(request) {
    var headers = this.addHeaders();
    return this.httpClient.get(environment.pssServerUrl + request.URL + request.DATA, { headers: headers })
      .map(res => res);
  }

  delete(request): Observable<any> {
    var headers = this.addHeaders();
    return this.httpClient.delete(environment.pssServerUrl + request.URL, { headers: headers })
      .pipe(
        map((data: any) => {
          return data;
        })
      );
  }

}
